export class ContainerTypeDTO {
  containerTypeId: string;
  containerTypeName: string;
  iconClass: string;
  isContainable: boolean | null;
  isContainer: boolean | null;
  isExternalData: boolean | null;
  isActive: boolean;
  modifiedBy: string | null;
  modifiedDate: string | null;
}
